function Backgroundtext(params) {
  return (
    <div id="background">
      <p id="bg-text">
        Click Anywhere on the screen <br /> to drop some circles.
      </p>
    </div>
  );
}

export default Backgroundtext;
